import { PropsWithChildren, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import colors from 'styles/colors.module.scss?export';
import { getBackgroundHoverColor, getHoverColor, isBackgroundLight } from 'utils/branding/brandingHelpers';
import { IAppTheme } from 'types/AppTheme';
import { useGetPortalSettingsQuery } from './slices';

const ThemeProviderProxy = ThemeProvider as any;

const DEFAULT_THEME: IAppTheme = {
  colors: {
    accentColor: '',
    brandColor: '',
    backgroundHoverAccentColor: '',
    hoverAccentColor: '',
    white100Base: colors.white100Base,
    secondary40: colors.secondary40,
    backgroundHoverBrandColor: '',
    hoverBrandColor: '',
    textBrandColor: '',
    textAccentColor: '',
    separatorColor: '',
  },
};

const AppTheme = ({ children }: PropsWithChildren<{}>) => {
  const [theme, setTheme] = useState<IAppTheme>(DEFAULT_THEME);

  const { currentData: settings } = useGetPortalSettingsQuery();

  const accentColor = settings?.branding?.accentColor;
  const brandColor = settings?.branding?.brandColor;

  useEffect(() => {
    if (accentColor && brandColor) {
      setTheme({
        colors: {
          ...theme.colors,
          accentColor: accentColor,
          brandColor: brandColor,
          backgroundHoverAccentColor: getBackgroundHoverColor(accentColor),
          hoverAccentColor: getHoverColor(accentColor),
          backgroundHoverBrandColor: getBackgroundHoverColor(brandColor),
          hoverBrandColor: getHoverColor(brandColor),
          textBrandColor: settings?.branding?.brandFontColor,
          textAccentColor: settings?.branding?.accentFontColor,
          separatorColor: isBackgroundLight(brandColor) ? colors.black100Base : colors.primary10,
        },
      });
    }
  }, [accentColor, brandColor, colors]);

  return (
    <ThemeProviderProxy theme={theme}>
      {children}
    </ThemeProviderProxy>
  );
};

export default AppTheme;
